import { Col, Row } from 'reactstrap';

import { useFormState } from 'utils/hooks';
import { getAsyncOptions, getInitialAsyncValues } from 'utils/helpers';
import Input from 'common/components/form/inputs/Input';
import Select from 'common/components/form/inputs/Select';
import SelectNew from '@/library/components/form/inputs/select';
import VesselsTypesSelector from 'common/components/selectors/VesselsTypesSelector';
import { unitOptions, frequencyOptions } from './options';
import Radio from '@/library/components/form/inputs/Radio';

const Body = ({ formState, marketIndexTypes }) => {
  const { fields, changeField, selectField } = useFormState(formState);
  return (
    <>
      <Row className="no-gutters">
        <Col>
          <Input label="NAME" onChange={changeField('name')} {...fields.name} />
        </Col>
      </Row>

      <Row className="no-gutters">
        <Col className="pe-1">
          <Select
            label="INDEX TYPE"
            onChange={selectField('type_id')}
            options={marketIndexTypes}
            {...fields.type_id}
          />
        </Col>
        <Col>
          <Select
            label="VALUE UNIT"
            onChange={selectField('value_unit')}
            options={unitOptions}
            {...fields.value_unit}
          />
        </Col>
      </Row>

      <Row className="no-gutters">
        <Col className="pe-1">
          <VesselsTypesSelector
            placeholder=" "
            label="Vessel Type"
            isMulti={false}
            onChange={selected => selectField('vessel_type_id')(selected?.value)}
            {...fields.vessel_type_id}
          />
        </Col>
        <Col>
          <Select
            isAsync
            label="VESSEL SUBTYPE"
            placeholder=""
            getOptionValue={option => option.id}
            getOptionLabel={option => option.name}
            loadOptions={search =>
              getAsyncOptions(
                search,
                'vessel-subtypes',
                fields.vessel_subtype.value && fields.vessel_subtype.value.id
                  ? { vessel_type_id: fields.vessel_subtype.value.id }
                  : null
              )
            }
            defaultOptions={() =>
              getInitialAsyncValues(
                'vessel-subtypes',
                null,
                false,
                fields.vessel_subtype.value && fields.vessel_subtype.value.id
                  ? { vessel_type_id: fields.vessel_subtype.value.id }
                  : null
              )
            }
            onChange={selectField('vessel_subtype')}
            isClearable
            {...fields.vessel_subtype}
          />
        </Col>
      </Row>

      <Row className="no-gutters">
        <Col className="pe-1">
          <Input
            label="VESSEL SIZE"
            onChange={changeField('vessel_size')}
            {...fields.vessel_size}
          />
        </Col>
        <Col>
          <Select
            options={frequencyOptions}
            label="FREQUENCY"
            onChange={selectField('frequency')}
            {...fields.frequency}
          />
        </Col>
      </Row>

      <Row className="no-gutters">
        <Col>
          <Input label="SOURCE" onChange={changeField('source')} {...fields.source} />
        </Col>
      </Row>

      <Row className="no-gutters">
        <Col>
          <Input label="ISSUER" onChange={changeField('issuer')} {...fields.issuer} />
        </Col>
      </Row>

      <strong className="text-primary fs-10">
        Set the single source of truth for the Values of the Index
      </strong>

      <Radio
        className="cmt-12 text-primary"
        label="Ocean"
        checked={fields.values_editable_by.value === null}
        onChange={() => {
          selectField('values_editable_by')(null);
        }}
      />
      <div className="d-flex align-items-center justify-content-between h-42">
        <Radio
          className="text-primary"
          label="A single Company"
          checked={fields.values_editable_by.value !== null}
          onChange={() => {
            selectField('values_editable_by')(undefined);
          }}
        />

        {fields.values_editable_by.value !== null && (
          <SelectNew
            className="w-45p"
            placeholder="Select company"
            memoizedRequestParams={{ path: '/lists', params: { list: 'organizations' } }}
            getOptionValue={opt => opt.id}
            getOptionLabel={opt => opt.name}
            onChange={selectField('values_editable_by')}
            {...fields.values_editable_by}
          />
        )}
      </div>
    </>
  );
};

export default Body;
